import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import MapRender from '@blade-sxp/map-new/index.vue';
import lang from '@blade-sxp/screen/lang/index';
import store from '@blade-sxp/screen/store/index';
import moment from 'moment';
import { LOADINGLINE } from '@blade-sxp/screen/constants/index';
let default_1 = class default_1 extends Vue {
    loadingLine = LOADINGLINE;
    get backMapUrl() {
        return store.backMapUrl;
    }
    get loading() {
        return store.loading;
    }
    get backMapZoneId() {
        return store.zoneId;
    }
    get weather() {
        return store.weather || 'auto';
    }
    get weatherConfig() {
        return store.weatherConfig;
    }
    get mainAngle() {
        return store.backMainAngle;
    }
    get backRootMainAngle() {
        return store.backRootMainAngle;
    }
    get ueMap() {
        return store.ueMap;
    }
    get timeConfig() {
        return store.timeConfig;
    }
    get backEndHighlightList() {
        return store.backEndHighlightList;
    }
    get backEndHeatMapList() {
        return store.backEndHeatMapList;
    }
    get backEndMarkerList() {
        return store.backEndMarkerList;
    }
    get backEndRoiList() {
        return store.backEndRoiList;
    }
    get backCurrentMainAngle() {
        return store.backCurrentMainAngle;
    }
    get sceneFlag() {
        return store.sceneFlag;
    }
    ueMapChange(ueMap) {
        if (ueMap) {
            if (!this.sceneFlag)
                return;
            store.updateWeatherConfig({ ...this.weatherConfig, uemap: true });
            if (this.timeConfig.timeType === 'FIX') {
                let todayDate = moment(new Date()).format('YYYY-MM-DD');
                console.log('currTime:', this.timeConfig.time);
                let date = new Date(`${todayDate} ${this.timeConfig.time}`);
                ueMap.closeDateTime(date.getTime());
            }
            else if (this.timeConfig.timeType === 'DAY_NIGHT_SHIFTING') {
                ueMap.openDateTime();
            }
            else if (this.timeConfig.timeType === 'REAL') {
                ueMap.closeDateTime(new Date().getTime());
            }
            if (this.weatherConfig?.weatherType !== 'REAL') {
                store.updateWeather(this.weatherConfig?.weatherType.toLowerCase());
            }
            else {
                store.updateWeather('');
            }
        }
    }
    async mapClick(e) {
        store.updateBackEventType(e);
    }
    mapOnEnd(ueMap) {
        store.updateWeatherConfig({ ...this.weatherConfig, uemap: true });
        store.updateUeMap(ueMap);
        // 更新视角
        store.updateBackMainAngle(this.backRootMainAngle);
        store.updateLoading(false);
        this.$nextTick(() => {
            store.updateIsShow(true);
        });
    }
};
__decorate([
    Watch('ueMap')
], default_1.prototype, "ueMapChange", null);
default_1 = __decorate([
    Component({
        name: 'backMap',
        components: {
            MapRender,
        },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
